import { Factory } from 'rosie';
import './lib/id';

Factory.define('EmailSuggestion').extend('Uuid');

Factory.define('EmailSuggestionWithDefaults')
  .extend('EmailSuggestion')
  .attr('email', 'example@gmail.com');
